import { BulkCreatePayeesRow } from '@willow/types-iso';

import { makeValidator } from '../shared/makeValidator';

export const validateBulkCreatePayees = makeValidator({
  FieldParser: BulkCreatePayeesRow,
});
